import axios, { AxiosInstance } from 'axios'

let tokapiAxiosInstance: AxiosInstance | null = null

export const initializeTokapiAxiosInstance = (tokapiServiceURL: string, ssoURL: string): AxiosInstance => {
    const instance = axios.create({
        baseURL: tokapiServiceURL,
        headers: {
            'Content-Type': 'application/json',
        },
        withCredentials: true,
        paramsSerializer: {
          indexes: null,
        }
    })

    instance.interceptors.response.use(
        (response) => response,

        (error) => {
            if (error.response?.status === 401 && error.response?.config?.baseURL === tokapiServiceURL) {
                console.warn(`Unauthorized request to toktokdoc API, redirecting to login page. URL: ${error.response.config.url}, error: ${error.message}`)
                window.location.href = ssoURL
            }
            return Promise.reject(error)
        },
    )

    tokapiAxiosInstance = instance
    return tokapiAxiosInstance
}

export const getTokapiAxiosInstance = (): AxiosInstance => {
    if (!tokapiAxiosInstance) {
        throw new Error('Tokapi Axios instance is not initialized')
    }
    return tokapiAxiosInstance
}
